<template>
    <div class="bg-gray-100">
        <TopLocationHero title-key="mocsenyi.title" static-image-key="mocsenyi___hero" />

        <div class="relative mt-4 sm:mt-12 z-1">
            <a id="main-content" class="fixed top-0" tabindex="-1"></a>

            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- INTRO -->
        <!-- * -->
        <div class="container relative z-2 mt-12">
            <Type6Block
                featured
                title-key="mocsenyi.intro.title"
                description-key="mocsenyi.intro.description"
                :images="galleryImages3"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- A BIT OF HISTORY -->
        <!-- * -->
        <div class="container relative z-2 mt-16 sm:mt-20">
            <Type9Block
                title-key="mocsenyi.history.title"
                description-key="mocsenyi.history.description"
                img-orientation-portrait
                static-image-key="mocsenyi___history"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- BEAUTIFUL FLORA -->
        <!-- * -->
        <div class="container relative z-2 mt-16 sm:mt-20 lg:mt-12">
            <Type3Block
                title-key="mocsenyi.flora.title"
                description-key="mocsenyi.flora.description"
                static-image-key="mocsenyi___flora"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- KNEIPP PATH -->
        <!-- * -->
        <div class="relative z-1 mt-16 sm:mt-20">
            <div class="container relative z-2">
                <Type9Block
                    title-key="mocsenyi.kneipp.title"
                    description-key="mocsenyi.kneipp.description"
                    class="z-1"
                    static-image-key="mocsenyi___kneipp"
                />
            </div>

            <TopLocationBackgroundShape4 flip-y flip-x class="-bottom-12 sm:-bottom-24 md:-bottom-28 lg:-bottom-44" />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- PICNIC & BIO CLASS -->
        <!-- * -->
        <div v-if="galleryImages1" class="relative z-2 mt-16 sm:mt-20">
            <Type2Block
                title-key="mocsenyi.picnic.title"
                description-key="mocsenyi.picnic.description"
                :images="galleryImages1"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- ACCORDION -->
        <!-- * -->
        <div v-if="galleryImages2" class="container relative z-2 mt-16 sm:mt-20">
            <Type5Block :items="galleryImages2" />
        </div>

        <div class="container mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('mocsenyi.event_recommendation_button_url').length && false"
                :button-text="$t('mocsenyi.event_recommendation_button_label')"
                :button-url="$t('mocsenyi.event_recommendation_button_url')"
                label-text-key="mocsenyi.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('mocsenyi.visit_project_button_label')"
                :button-url="$t('mocsenyi.visit_project_button_url')"
                label-text-key="mocsenyi.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import Type3Block from '@/components/Blocks/Type3Block/Type3Block.vue';
import Type2Block from '@/components/Blocks/Type2Block/Type2Block.vue';
import Type5Block from '@/components/Blocks/Type5Block/Type5Block.vue';
import Type9Block from '@/components/Blocks/Type9Block/Type9Block.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';
import Type6Block from '@/components/Blocks/Type6Block/Type6Block.vue';
import TopLocationBackgroundShape4 from '@/components/Pages/TopLocation/TopLocationBackgroundShape4.vue';

export default {
    name: 'MocsenyiMihalyBotanicalGarden',
    components: {
        AwardsBlock,
        TopLocationProjectPageBanner,
        TopLocationBackgroundShape4,
        Type6Block,
        TopLocationBackgroundShape1,
        TopLocationHero,
        Type3Block,
        Type2Block,
        Type5Block,
        Type9Block,
    },
    async asyncData({ $axios, i18n }) {
        let galleryImages1 = null;
        let galleryImages2 = null;
        let galleryImages3 = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/galleries/reference/top-location___mocsenyi-1'),
            $axios.$get('/galleries/reference/top-location___mocsenyi-2'),
            $axios.$get('/galleries/reference/top-location___mocsenyi-3'),
            $axios.$get('/awards/reference/mocsenyi'),
        ])
            .then(([galleryImages1Res, galleryImages2Res, galleryImages3Res, awardsRes]) => {
                if (galleryImages1Res.status === 'fulfilled') {
                    galleryImages1 = galleryImages1Res.value.slides;
                }

                if (galleryImages2Res.status === 'fulfilled') {
                    galleryImages2 = galleryImages2Res.value.slides;
                }

                if (galleryImages3Res.status === 'fulfilled') {
                    galleryImages3 = galleryImages3Res.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('mocsenyi.title'), 'mocsenyi-mihaly-botanical-garden']);

        return {
            galleryImages1,
            galleryImages2,
            galleryImages3,
            awards,
            breadcrumbItems,
        };
    },
    data() {
        return {};
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.mocsenyi-botanical-garden'),
            meta: this.$getPageMetaData('top-locations.mocsenyi-botanical-garden'),
        };
    },
};
</script>

<style scoped></style>
